import { USER_ROLES } from 'admin/users/userUtils';
import { SelectInput } from 'react-admin';

interface Props {
  source: string;
  disabled?: boolean;
  label?: string;
}

export const RoleInput: React.FC<Props> = ({ disabled, label, source }) => {
  return (
    <SelectInput
      choices={USER_ROLES}
      disabled={disabled}
      label={label}
      optionText="name"
      optionValue="id"
      source={source}
      sx={{ width: '40em' }}
      translateChoice={false}
    />
  );
};
